
module.exports = function () {
    $(document).ready(function () {

        $('.NavMain__toggle').on('click', function () {
            $('#app').toggleClass('NavMain__open');
        });

    });
};



// WEBPACK FOOTER //
// ./resources/assets/js/public/nav-toggle.js